import { Link } from "react-router-dom";
import { Mail, Heart } from "lucide-react";

const UHL_LOGO =
  "https://customer-assets.emergentagent.com/job_ubl-hoops/artifacts/guzx5yt0_ChatGPT%20Image%20Apr%2020%2C%202026%2C%2009_02_19%20AM.png";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-900 text-slate-300 mt-20"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4 mb-5">
            <img
              src={UHL_LOGO}
              alt="UHL — Unified Hoops League"
              className="h-16 w-auto object-contain"
            />
          </div>
          <p className="text-slate-400 max-w-md leading-relaxed">
            An inclusive, free basketball program for kids with intellectual
            and developmental disabilities. Built on teamwork, confidence,
            and a whole lot of fun.
          </p>
          <a
            href="mailto:unifiedhoopsleague@gmail.com"
            data-testid="footer-email-link"
            className="inline-flex items-center gap-2 mt-5 text-orange-400 hover:text-orange-300 font-bold transition-colors"
          >
            <Mail className="w-4 h-4" />
            unifiedhoopsleague@gmail.com
          </a>
        </div>

        <div>
          <p className="text-white font-black mb-4 uppercase tracking-wider text-sm">
            Explore
          </p>
          <ul className="space-y-2">
            {[
              ["Home", "/"],
              ["About", "/about"],
              ["Program", "/program"],
              ["Gallery", "/#gallery"],
            ].map(([label, to]) => (
              <li key={label}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase()}`}
                  className="hover:text-orange-400 transition-colors font-semibold"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-white font-black mb-4 uppercase tracking-wider text-sm">
            Get Involved
          </p>
          <ul className="space-y-2">
            {[
              ["Register a Player", "/register"],
              ["Become a Volunteer", "/volunteer"],
              ["Donate / Support UHL", "/donate"],
              ["Parent Forms", "/forms"],
              ["Contact Us", "/contact"],
            ].map(([label, to]) => (
              <li key={label}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                  className="hover:text-orange-400 transition-colors font-semibold"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-500">
          <p className="font-semibold">
            © {new Date().getFullYear()} Unified Hoops League. All rights reserved.
          </p>
          <p className="flex items-center gap-2 font-semibold">
            Built with <Heart className="w-4 h-4 text-orange-500 fill-orange-500" /> for inclusion.
          </p>
        </div>
      </div>
    </footer>
  );
}
